module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/documents-0906c59301090fcf67d9a70826f0ea60.svg";